import React from 'react';
import DocumentTitle from './DocumentTitle';
import { text } from './Text';

export default function Unauthorized({ message }) {
  return (
    <>
      {message && <DocumentTitle title={text('common.access_denied')} />}
      <div className="col-12 align-center">
        <p className="align-center content-page-title">{message}</p>
      </div>
    </>
  );
}
